import { ServiceProvider } from '@/types';
import { Core, SERVICE_PROVIDERS } from '../Core';

class ServiceProviders extends Core {
  getServiceProviders = async () =>
    this.get<ServiceProvider[]>(SERVICE_PROVIDERS());
}

export const serviceProviders = new ServiceProviders();
